/**
 * Routing
 */

// Views
const Intro = r => require.ensure([], () => r(require('@/views/Intro')), 'INTRO_GROUP')
const Main = r => require.ensure([], () => r(require('@/views/Main')), 'MAIN_GROUP')
const Admin = r => require.ensure([], () => r(require('@/views/Admin')), 'ADMIN_GROUP')

// Partials
const Notifications = r => require.ensure([], () => r(require('@/views/partials/Notifications')), 'ADMIN_GROUP')
const Dynamic = r => require.ensure([], () => r(require('@/views/partials/Dynamic')), 'MAIN_GROUP')
const DynamicItem = r => require.ensure([], () => r(require('@/views/partials/DynamicItem')), 'MAIN_GROUP')
const DynamicModal = r => require.ensure([], () => r(require('@/views/partials/DynamicModal')), 'MAIN_GROUP')
const Shows = r => require.ensure([], () => r(require('@/views/partials/Shows')), 'MAIN_GROUP')

// Components
const Nav = r => require.ensure([], () => r(require('@/components/Nav')), 'MAIN_GROUP')
const AdminNav = r => require.ensure([], () => r(require('@/components/AdminNav')), 'ADMIN_GROUP')
const Show = r => require.ensure([], () => r(require('@/components/Show')), 'MAIN_GROUP')

// Routes
const routes = [
	{
		path: '/',
		component: Intro,
		meta: {
			requiresAuth: false,
			title: 'Intro',
		},
		children: [
			{
				path: '',
				name: 'shows',
				component: Shows,
			},
			{
				path: ':show?',
				name: 'show',
				component: Show,
			},
			{
				path: ':show/admin',
				meta: {
					requiresAuth: false,
				},
				component: Admin,
				children: [
					{
						path: '',
						components: {
							nav: AdminNav,
							content: Notifications,
						},
					},
				],
			},
			{
				path: ':show/:type',
				component: Main,
				children: [
					{
						path: '',
						name: 'content',
						components: {
							nav: Nav,
							content: Dynamic,
						},
					},
					{
						path: ':id',
						name: 'item',
						components: {
							nav: Nav,
							content: DynamicItem,
						},
						children: [
							{
								path: ':modalType/:modalId',
								name: 'modal',
								components: {
									modal: DynamicModal,
								},
								meta: {
									showModal: true,
								},
							},
						],
					},
				],
			},
		],
	},
]

export default routes



// WEBPACK FOOTER //
// ./src/lib/router/routes.js